import { FORM_TYPES } from "SharedStores/Form/formStore";
import { PROJECT_TYPES } from "SharedStores/Project/projectStore";
import { SUFFIXES } from "Forms/Components/Elements/_elementBase";

export function GetAddressFromDependency($app, getters, sourceElementId) {
    const sourceElement = getters[FORM_TYPES.getters.elementFromId](sourceElementId);
    if (!sourceElement) {
        return null;
    }

    const address = GetUSACAAddress(getters, sourceElement);
    // Return an empty string if address is empty to prevent unneccesary geocoding
    if (!address) {
        return "";
    }

    switch ($app.DateCultureMessageInfo.Locale) {
        // add new cases as exceptions, or use the default address structure
        case "en-CA":
            return address + " CA";
        case "es-SV":
            return address + " SV";
        default:
            return address + " USA";
    }
}

function GetUSACAAddress(getters, sourceElement) {
    const addressDataBySuffix = {};
    const suffixesOrder = [
        SUFFIXES.Address.Line1,
        SUFFIXES.Address.Line2,
        SUFFIXES.Address.City,
        SUFFIXES.Address.State,
        SUFFIXES.Address.ZipCode
    ];

    for (const suffix in sourceElement.GroupDataFields) {
        const dataFieldId = sourceElement.GroupDataFields[suffix];
        const dataValue = getters[PROJECT_TYPES.getters.dataFieldValueFromId](dataFieldId);
        addressDataBySuffix[suffix] = dataValue;
    }

    let address = "";
    for (const suffix of suffixesOrder) {
        if (addressDataBySuffix[suffix]) {
            address += addressDataBySuffix[suffix] + " ";
        }
    }

    return address.trim();
}

export function IsAddressCompleteEnoughForAutoGeocode($app, getters, sourceElementId) {
    const sourceElement = getters[FORM_TYPES.getters.elementFromId](sourceElementId);
    if (!sourceElement) {
        return null;
    }

    switch ($app.DateCultureMessageInfo.Locale) {
        // add new cases as exceptions, or use the default address structure
        default:
            return IsUSACAAddressMostlyComplete(getters, sourceElement);
    }
}

function IsUSACAAddressMostlyComplete(getters, sourceElement) {
    // The address is considered complete enough for auto-geocoding if it has all of the following fields:
    const expectedSuffixes = [SUFFIXES.Address.City, SUFFIXES.Address.State, SUFFIXES.Address.ZipCode];

    for (const suffix of expectedSuffixes) {
        if (!sourceElement.GroupDataFields[suffix]) {
            return false;
        }
        const dataFieldId = sourceElement.GroupDataFields[suffix];
        const dataValue = getters[PROJECT_TYPES.getters.dataFieldValueFromId](dataFieldId);
        if (!dataValue) {
            return false;
        }
    }

    return true;
}
